import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// let test = false

const Option = props => {
  // if (test) {
  //   console.log(props)
  // }
  // test = true
  const { airport } = props.data
  const optionalCityWithComma = airport.city ? `${airport.city}, ` : ''
  // const optionalRegionWithComma =
  //   airport.region && airport.region !== airport.city
  //     ? `${airport.region}, `
  //     : ''
  const hasIataOrIcao = 'iata' in airport || 'icao' in airport

  return (
    <div
      className={classnames([
        'airport-option',
        {
          'airport-option--focused': props.isFocused,
          'airport-option--disabled': props.isDisabled,
        },
      ])}
      {...props.innerProps}
    >
      <div className='grid-x grid-margin-x'>
        <div className='auto cell airport-option__title'>{airport.name}</div>
        {hasIataOrIcao && (
          <div className='shrink cell airport-option__code'>
            {airport.iata} {airport.icao}
          </div>
        )}
      </div>
      <div className='grid-x grid-margin-x airport-option__gray'>
        <div className='auto cell'>
          {optionalCityWithComma}
          {/* {optionalRegionWithComma} */}
          {airport.country}
        </div>
        {/* <div className='shrink cell'>
          {airport.type || 'Airport'}
        </div> */}
      </div>
    </div>
  )
}

Option.propTypes = {
  innerProps: PropTypes.object,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  data: PropTypes.shape({
    airport: PropTypes.shape({
      city: PropTypes.string,
      country: PropTypes.string,
      iata: PropTypes.string,
      icao: PropTypes.string,
      name: PropTypes.string,
      region: PropTypes.string,
      type: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

export default Option
